import { createSelector } from 'reselect'

import onboardingGuideCardSelector from '../onboarding_guide_card_selector'
import onboardingGuideCardTypes from 'helpers/enums/onboardingGuideCardTypes'
import onboardingGuideCardStatusTypes from 'helpers/enums/onboardingGuideCardStatusTypes'

const cardSelector = onboardingGuideCardSelector(onboardingGuideCardTypes.LESSON_BUILDER)

const onboardingGuideLessonBuilderSelector = createSelector(
	[cardSelector],
	card => ({
		status: card.status || onboardingGuideCardStatusTypes.PENDING,
	})
)

export default onboardingGuideLessonBuilderSelector
